import { render } from "./OverallAuthorStatistics.vue?vue&type=template&id=219f59aa&scoped=true"
import script from "./OverallAuthorStatistics.vue?vue&type=script&lang=js"
export * from "./OverallAuthorStatistics.vue?vue&type=script&lang=js"

import "./OverallAuthorStatistics.vue?vue&type=style&index=0&id=219f59aa&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219f59aa"]])

export default __exports__